import { useEffect, useState } from 'react';
import { clienteService } from '../../services/api';
import '../../styles/Clientes.css';

const EliminarCliente = () => {
  const [clientes, setClientes] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [clienteInfo, setClienteInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadClientes();
  }, []);

  const loadClientes = async () => {
    try {
      const resp = await clienteService.getClientes({ per_page: 200 });
      setClientes((resp.data?.clientes || []).map(c => ({
        id: c.id,
        nombre: `${c.nombres} ${c.apellidos}`,
        cedula: c.cedula
      })));
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo cargar la lista de clientes');
    }
  };

  const loadClienteInfo = async (id) => {
    if (!id) return;
    setLoading(true);
    setError('');
    try {
      const resp = await clienteService.getCliente(id);
      setClienteInfo(resp.data);
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo cargar el cliente');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedId) {
      loadClienteInfo(selectedId);
    } else {
      setClienteInfo(null);
    }
  }, [selectedId]);

  const handleDelete = async () => {
    if (!selectedId || !clienteInfo) return;

    const confirmacion = window.confirm(
      `¿Está seguro que desea eliminar al cliente ${clienteInfo.nombres} ${clienteInfo.apellidos}?\n\nEsta acción no se puede deshacer.`
    );

    if (!confirmacion) return;

    setLoading(true);
    setError('');
    setMessage('');

    try {
      await clienteService.deleteCliente(selectedId);
      setMessage('Cliente eliminado exitosamente');
      setSelectedId('');
      setClienteInfo(null);
      // Recargar la lista
      loadClientes();
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudo eliminar el cliente');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Eliminar Cliente</h1>
      </div>

      {error && <div className="banner error">{error}</div>}
      {message && <div className="banner ok">{message}</div>}

      <div className="card">
        <div className="field">
          <label>Seleccionar Cliente</label>
          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
            disabled={loading}
          >
            <option value="">-- Seleccione un cliente --</option>
            {clientes.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nombre} - {c.cedula}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading && <div className="loading">Cargando...</div>}

      {clienteInfo && !loading && (
        <div className="card" style={{marginTop: '1rem'}}>
          <div className="card-title" style={{background: '#c62828'}}>
            Información del Cliente
          </div>
          <div className="grid-2">
            <div className="field">
              <label>Nombres</label>
              <div>{clienteInfo.nombres}</div>
            </div>
            <div className="field">
              <label>Apellidos</label>
              <div>{clienteInfo.apellidos}</div>
            </div>
            <div className="field">
              <label>Cédula</label>
              <div>{clienteInfo.cedula}</div>
            </div>
            <div className="field">
              <label>Apodo</label>
              <div>{clienteInfo.apodo || 'N/A'}</div>
            </div>
            <div className="field">
              <label>Teléfono</label>
              <div>{clienteInfo.telefono || 'N/A'}</div>
            </div>
            <div className="field">
              <label>Celular</label>
              <div>{clienteInfo.celular || 'N/A'}</div>
            </div>
            <div className="field" style={{gridColumn: '1 / span 2'}}>
              <label>Dirección</label>
              <div>{clienteInfo.direccion || 'N/A'}</div>
            </div>
          </div>

          <div className="form-actions" style={{marginTop: '1.5rem'}}>
            <button
              type="button"
              className="btn"
              style={{background: '#c62828', color: '#fff'}}
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? 'Eliminando...' : 'Eliminar Cliente'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EliminarCliente;
